import {
  Component,
  ChangeDetectionStrategy,
  signal,
  viewChild,
  effect,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Webhooks } from './shared/webhooks/webhooks-list';
import { WebhookFailures } from './shared/webhook-failures/webhook-failures';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { readTabFromQueryParams, syncTabToUrl } from '@tourfold/libraries/shared-util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const TAB_VALUES = ['webhooks', 'failures'] as const;

@Component({
  selector: 'tf-settings-page-webhooks',
  imports: [CommonModule, Webhooks, WebhookFailures, TranslateModule, TabsModule],
  templateUrl: './settings-webhooks.component.html',
  styleUrl: './settings-webhooks.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebhooksSettings {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  readonly activeTab = signal(
    readTabFromQueryParams(this.route.snapshot.queryParams, 'tab', TAB_VALUES, 'webhooks')
  );
  readonly webhookFailuresComponent = viewChild(WebhookFailures);

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.activeTab.set(readTabFromQueryParams(params, 'tab', TAB_VALUES, 'webhooks'));
    });

    // Refresh failures when switching to failures tab
    effect(() => {
      const tab = this.activeTab();
      const failuresComponent = this.webhookFailuresComponent();

      if (tab === 'failures' && failuresComponent) {
        // Small delay to ensure component is fully initialized
        setTimeout(() => {
          failuresComponent.refreshFailures();
        }, 0);
      }
    });
  }

  onTabChange(tab: string): void {
    this.activeTab.set(tab);
    syncTabToUrl(this.router, this.route, 'tab', tab);
  }
}
